<template>

  <div class="  productPrice300">
    <div class="col-12">
      <template v-if="offer">
        <del>
          <span class=" d-block mb-2" v-html="$t('price.price',{currency:formatNumber(priceBeforeOffer  )})"></span>
        </del>
      </template>
      <span v-if="offer > 0" class="badge badge-danger p-1">{{ offerPercentValue }} %</span>
      <span class="mr-2" v-html="$t('price.price',{currency:formatNumber(price)})"></span>


    </div>
  </div>


</template>

<script>
import {formatNumber, flatten} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  getProductPriceRange,
  getProductOfferRange,
  productOfferChecker
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {checkProductHaveFormula} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "ProductPrice300",
  props: {
    product: {}
  },
  data() {
    return {
      offer: 0,
      price: 0,
      priceBeforeOffer: 0,
      offerPercentValue: 0,
    }
  },
  computed: {
    productPriceRange() {
      return this.getProductPriceRange(this.product)
    },
    productOfferRange() {
      return this.getProductOfferRange(this.product)
    }
  },
  methods: {
    checkProductHaveFormula,
    formatNumber,
    getProductPriceRange,
    getProductOfferRange,
    productOfferChecker,
    flatten,
    productOfferWrapper() {
      const variation = this.product.variation
      if (variation == 1) {
        let offer = this.getProductOfferRange(this.product, 'object')['max'];
        offer = parseInt(offer)
        this.priceBeforeOffer = parseInt(offer) + this.productPriceWrapper()
        return offer
      }
      return this.product.offer
    },
    productPriceWrapper() {
      const variation = this.product.variation
      if (variation == 1) {
        return this.getProductPriceRange(this.product, 'object')['max']
      }
      return this.product.price
    },
    offerPercent(price, offer) {
      return Math.round((offer * 100) / price)
    },
    initOffer() {
      let offer = this.productOfferWrapper(this.product)
      let price = this.productPriceWrapper(this.product)
      this.offerPercentValue = this.offerPercent(this.priceBeforeOffer, offer)
    },
    init() {
      this.initOffer()
      let price = this.productPriceWrapper()
      let offer = this.productOfferWrapper()


      this.offer = offer
      this.price = price

    }
  },
  updated() {
    this.init()
  },
  mounted() {
    this.init()
  },

}
</script>

<style scoped>
</style>